import { render, staticRenderFns } from "./SurveysTable.vue?vue&type=template&id=8e12943e&"
import script from "./SurveysTable.vue?vue&type=script&lang=js&"
export * from "./SurveysTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports